import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Tooltip } from '@mui/material';

export const InfoButtonIcon = ({ onClick, title }: any) => {
  return (
    <Tooltip onClick={onClick} title={title}>
      <IconButton aria-label="details">
        <InfoOutlineRoundedIcon style={{ fill: '#16a34a', fontSize: '22px' }} />
      </IconButton>
    </Tooltip>
  );
};
